<script lang="ts">
    import type { Snippet } from "svelte";
    import { translate } from "@/utils/format";
    import { sectionDef, type SectionId } from "../lib/sections";

    let { id, children }: { id: SectionId; children?: Snippet } = $props();
    const def = $derived(sectionDef(id));
</script>

<header class="sectionHeader">
    <div class="sectionHeader__text">
        <h2>{translate(def.labelKey, def.label)}</h2>
        <p>{translate(def.descKey, def.desc)}</p>
    </div>
    {#if children}
        <div class="sectionHeader__actions">{@render children()}</div>
    {/if}
</header>
